import axios from 'axios';

const api = axios.create({
  // baseURL:  'http://192.168.20.176:1803/api',
     baseURL:  `${window.config.env.BASE_API_URL}/api`,
  // baseURL: 'http://web.service.test.imango.loc/api'
  // baseURL: 'http://localhost:8000/api/agents',
  // baseURL: 'http://imango.white.ge/api/agents',
});

const vehicle = {
  // api.vehicle.categories()
  categories: () => {
    return api.get('core/categories?embed=products');
  },
  // api.products(id)
  products: id => {
    return api.get(`core/categories/${id}/products`);
  },
  manufacturers: () => {
    return api.get(`core/vehicles/manufacturers`);
  },
  models: id => {
    return api.get(`core/vehicles/manufacturers/${id}/models`);
  },
  countries: () => {
    return api.get(`core/countries`);
  },
};

const ecommerce = {
	getEcommerceList: () => {
	  return api.get(`ecommerce/List`);
	},
}

const policy = {
  create: (data = {}) => {
    return api.post('policies', data);
  },
  
  findPolicy: (data = {}) => {
    let url = `/policies/findPolicy?`
    data.vinCode ? url = url.concat(`vinCode=${data.vinCode}`) : url;
    data.chassisNumber ? url=  url.concat (`&chassisNumber=${data.chassisNumber}`) : url;
    data.registrationNumber ? url= url.concat(`&registrationNumber=${data.registrationNumber}`) : url;
    data.policyNumber ? url= url.concat( `&policyNumber=${data.policyNumber}`) : url;

    return api.get(url);
  },
  payments: (id, data = {}) => {
    return api.post(`policies/${id}/payments`, data);
  },

  getPolicy: id => {
    return api.get(`policies/${id}`);
  },

  getPolicyDocuments: id => {
    return api.get(`policies/${id}/documents`);
  },
  getFraudMessage: language => {
    return api.get(`policies/fraudMessages/${language}`)
  }
};

const maps = {
   getMap: () => { return api.get("core/salespoints") }
};

export default {
  vehicle,
  policy,
  maps,
  ecommerce
};



// WEBPACK FOOTER //
// ./src/api/index.js